export const yachtsData = [
    {
        id: 1,
        name: "Lorenzo Supra",
        price: 600,
        size: 65,
        capacity: 30,
        crew: 3,
        images: [
            "assets/images/48aay-B2B__1.jpg",
            "assets/images/yacht-slider-1.jpg",
            "assets/images/yacht-slider-2.jpg",
            "assets/images/yacht-slider-3.jpg",
        ],
    },
    {
        id: 2,
        name: "Ocean Explorer",
        price: 750,
        size: 70,
        capacity: 35,
        crew: 4,
        images: [
            "assets/images/56370_Screenshot_2024-07-01_163155.png",
            "assets/images/yacht-slider-2.jpg",
            "assets/images/yacht-slider-1.jpg",
            "assets/images/yacht-slider-3.jpg",
        ],
    },
    {
        id: 3,
        name: "Sea Breeze",
        price: 500,
        size: 60,
        capacity: 25,
        crew: 2,
        images: [
            "assets/images/46193_115yb-min.jpg",
            "assets/images/yacht-slider-3.jpg",
            "assets/images/yacht-slider-1.jpg",
            "assets/images/yacht-slider-2.jpg",
        ],
    },
    {
        id: 4,
        name: "Sea Breeze",
        price: 500,
        size: 60,
        capacity: 25,
        crew: 2,
        images: [
            "assets/images/33915_Mask_group-6-min.jpg",
            "assets/images/yacht-slider-3.jpg",
            "assets/images/yacht-slider-1.jpg",
            "assets/images/yacht-slider-2.jpg",
        ],
    },
    {
        id: 5,
        name: "Sea Breeze",
        price: 500,
        size: 60,
        capacity: 25,
        crew: 2,
        images: [
            "assets/images/19960_Mask_group-5.jpg",
            "assets/images/yacht-slider-3.jpg",
            "assets/images/yacht-slider-1.jpg",
            "assets/images/yacht-slider-2.jpg",
        ],
    },
];

export const testimonialsData = [
    {
        id: 1,
        data: "I booked a yacht rental in Dubai for my birthday with Blue Harbour, and the experience was beyond perfect! The captain was experienced, the crew was attentive, the decor was stunning, and everything felt luxurious from start to finish. Easily the best yacht rental Dubai Marina.",
        name:'Fatima El-Sayed',
        location: 'Berlin, Germany'
    },
    {
        id: 2,
        data: "Spending my anniversary on a luxury yacht rental in Dubai was a once-in-a-lifetime experience. From exotic food to the personalised service, it was flawless. Definitely the best yacht rental Dubai has to offer.",
        name:'Sophia Turner',
        location: 'Austin, Texas, USA'
    },
    {
        id: 3,
        data: "We browsed many yacht rental prices in Dubai, and Blue Harbour stood out for offering incredible value without compromising on luxury. From booking to sailing, the process was seamless and professional.",
        name:'Lucas Moreau',
        location: 'Lyon, France'
    },
    {
        id: 4,
        data: "Hands down the best yacht rental in Dubai Marina. Every detail was perfectly taken care of, from the stunning decor to the friendly crew. Already planning to book again for an unforgettable New Year’s Eve yacht rental in Dubai. ",
        name:'Aarav Mehta',
        location: 'Mumbai, India'

    },
    {
        id: 5,
        data: "Planning a celebration or an event? Blue Harbour is the way to go. We booked a yacht rental in Dubai for a party, and the team handled the event spectacularly- food, music, and water activities. It was luxury and fun rolled into one!",
        name:'Kenji Sato',
        location:'Kyoto, Japan'
    },
];
export const servicesData = [
    {
        id: 1,
        serviceName: "Catering – A Culinary Voyage at Sea",
        metaData: "Savour the finest flavours with our yacht catering services, where every dish is a masterpiece. At Blue Harbour, our expert chefs bring world-class culinary skills to your private yacht, crafting menus that blend fresh, high-quality ingredients with exquisite presentation.",
        data: [
            { text: "Savour the finest flavours with our yacht catering services, where every dish is a masterpiece. At Blue Harbour, our expert chefs bring world-class culinary skills to your private yacht, crafting menus that blend fresh, high-quality ingredients with exquisite presentation.", tag: "p" },
            { text: "From succulent seafood to delicious entrées and rich desserts, every bite is designed to elevate your yacht catering experience. Whether it’s an intimate dinner or a lavish event, our seamless yacht rental catering service ensures that your dining experience is as unforgettable as the breathtaking Dubai waters around you.", tag: "p" },
            { text: "A Feast for the Senses – Reserve Your Yacht Catering Today!", tag: "h4" },
            { text: "Let our chefs take you on a flavoursome journey at sea. Elevate your Dubai yacht rental with handcrafted meals, impeccable service, and unforgettable flavours. Book your catering experience now.", tag: "p" }
        ]
    },
    {
        id: 2,
        serviceName: "Decor – Transforming Yachts into Breathtaking Venues",
        metaData: "Imagine stepping onto a luxurious yacht with the perfect view, exquisite food, and a stunning atmosphere—except something feels off. The space looks plain, lacking the charm that makes an event unforgettable.",
        data: [
            { text: "Imagine stepping onto a luxurious yacht with the perfect view, exquisite food, and a stunning atmosphere—except something feels off. The space looks plain, lacking the charm that makes an event unforgettable. ", tag: "p" },
            { text: "That’s where our yacht decoration team comes in. At Blue Harbour, our expert decorators on a yacht craft stunning setups tailored to your occasion. From elegant floral arrangements to themed boat party decorations, every detail is designed to create a visually captivating experience, ensuring your Dubai yacht rental is nothing short of spectacular.", tag: "p" },
            { text: "Set the Scene for Perfection – Book Your Yacht Decor Now!", tag: "h4" },
            { text: "A beautifully decorated yacht enhances every moment. Let our team transform your Dubai luxury yacht rental into a stunning setting that matches your vision. Contact us today for custom decor!", tag: "p" }
        ]
    },
    {
        id: 3,
        serviceName: "Watersports – Take Your Yacht Experience to the Next Level",
        metaData: "Sailing across the ocean is incredible, but adding an adrenaline rush makes it unforgettable. Why just float when you can dive, glide, and ride the waves? Blue Harbour’s watersports in Dubai offer an exciting mix of activities, from paddleboarding and wakeboarding to snorkelling in crystal-clear waters.",
        data: [
            { text: "Sailing across the ocean is incredible, but adding an adrenaline rush makes it unforgettable. Why just float when you can dive, glide, and ride the waves? Blue Harbour’s watersports in Dubai offer an exciting mix of activities, from paddleboarding and wakeboarding to snorkelling in crystal-clear waters.", tag: "p" },
            { text: "Whether you're looking for adventure or just a splash of fun, our team ensures a safe, thrilling experience. Elevate your Dubai yacht rental with action-packed water activities that will leave you craving more.", tag: "p" },
            { text: "Make a Splash – Add Watersports to Your Yacht Rental!", tag: "h4" },
            { text: "Adventure meets luxury on the water. Enhance your Dubai yacht charter with exhilarating watersports tailored to your thrill level. Book now for an unforgettable ocean adventure!", tag: "p" }
        ]
    },
    {
        id: 4,
        serviceName: "Jet Ski Rentals – Ride the Waves with Speed and Style",
        metaData: "There’s no feeling quite like racing over the ocean, wind in your hair, and endless blue ahead. Our Dubai jet ski rentals bring pure excitement to your yacht getaway. Whether you're an experienced rider or a first-timer, our top-tier jet skis provide a smooth, safe, and heart-pounding ride along the stunning Dubai coastline.",
        data: [
            { text: "There’s no feeling quite like racing over the ocean, wind in your hair, and endless blue ahead. Our Dubai jet ski rentals bring pure excitement to your yacht getaway. Whether you're an experienced rider or a first-timer, our top-tier jet skis provide a smooth, safe, and heart-pounding ride along the stunning Dubai coastline.", tag: "p" },
            { text: "Add the thrill of jet skiing in Dubai to your luxury yacht experience and turn a perfect day on the water into an adventure you'll never forget.", tag: "p" },
            { text: "Speed, Splash, and Unstoppable Fun – Book Your Jet Ski Today!", tag: "h4" },
            { text: "Feel the rush of Dubai’s waters with a high-speed jet ski rental in Dubai Beach. Perfect for solo rides or friendly races—reserve your jet ski now!", tag: "p" }
        ]
    },
    {
        id: 5,
        serviceName: "Luxury Car Transport – Arrive in Style, Step Aboard in Elegance",
        metaData: "Your yacht experience begins long before you set foot on the deck. Why settle for an ordinary arrival when you can make a statement? Our luxury car transport service ensures a seamless, stylish transition from land to sea. Glide up to the marina in a chauffeur-driven limousine, a sleek sedan, or an exotic supercar, setting the tone for the lavish journey ahead. Whether for a romantic evening or a grand celebration, your arrival should be as extraordinary as your voyage.",
        data: [
            { text: "Your yacht experience begins long before you set foot on the deck. Why settle for an ordinary arrival when you can make a statement? Our luxury car transport service ensures a seamless, stylish transition from land to sea. Glide up to the marina in a chauffeur-driven limousine, a sleek sedan, or an exotic supercar, setting the tone for the lavish journey ahead. Whether for a romantic evening or a grand celebration, your arrival should be as extraordinary as your voyage.", tag: "p" },
            { text: "Luxury from Start to Finish – Book Your Ride Today!", tag: "h4" },
            { text: "Enhance your Dubai yacht charter with VIP transport in high-end vehicles. Let us take care of every detail—reserve your luxury car transfer now!", tag: "p" }
        ]
    },
]